import { Avatar, Stack, Typography } from '@mui/material';
import { PaychecksNoData } from 'Images';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useIsDesktop } from 'Hooks';

export const NoData = () => {
  const isDesktop = useIsDesktop();
  const dictionary = Dictionary[DICTIONARY.Home].userPaychecks;

  return (
    <Stack sx={{ justifyContent: 'center', alignItems: 'center' }}>
      <Typography variant='body2' mb={1}>
        {dictionary.noData}
      </Typography>
      <Typography variant='body2' mb={isDesktop ? 5 : 2.5}>
        {dictionary.noDataSubtitle}
      </Typography>
      <Avatar
        sx={{
          width: '250px',
          height: '240px',
          mb: 2,
        }}
        src={PaychecksNoData}
        alt={''}
      />
    </Stack>
  );
};
